import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
/**
 * View in the database represented in this class.
 */
export var View = /*#__PURE__*/function () {
  // -------------------------------------------------------------------------
  // Constructor
  // -------------------------------------------------------------------------
  function View(options) {
    _classCallCheck(this, View);
    this["@instanceof"] = Symbol.for("View");
    this.indices = [];
    if (options) {
      this.database = options.database;
      this.schema = options.schema;
      this.name = options.name;
      this.expression = options.expression;
      this.materialized = !!options.materialized;
    }
  }
  // -------------------------------------------------------------------------
  // Public Methods
  // -------------------------------------------------------------------------
  /**
   * Clones this table to a new table with all properties cloned.
   */
  _createClass(View, [{
    key: "clone",
    value: function clone() {
      return new View({
        database: this.database,
        schema: this.schema,
        name: this.name,
        expression: this.expression,
        materialized: this.materialized
      });
    }
    /**
     * Add index
     */
  }, {
    key: "addIndex",
    value: function addIndex(index) {
      this.indices.push(index);
    }
    /**
     * Remove index
     */
  }, {
    key: "removeIndex",
    value: function removeIndex(viewIndex) {
      var index = this.indices.find(function (index) {
        return index.name === viewIndex.name;
      });
      if (index) {
        this.indices.splice(this.indices.indexOf(index), 1);
      }
    }
    // -------------------------------------------------------------------------
    // Static Methods
    // -------------------------------------------------------------------------
    /**
     * Creates view from a given entity metadata.
     */
  }], [{
    key: "create",
    value: function create(entityMetadata, driver) {
      var options = {
        database: entityMetadata.database,
        schema: entityMetadata.schema,
        name: driver.buildTableName(entityMetadata.tableName, entityMetadata.schema, entityMetadata.database),
        expression: entityMetadata.expression,
        materialized: entityMetadata.tableMetadataArgs.materialized
      };
      return new View(options);
    }
  }]);
  return View;
}();